import React, { useRef } from "react";
import $ from "jquery";

import BuddibleSocket from "../lib/BuddibleSocket";
import Utilities from "../lib/Utilities";
import CodeList from "../lib/CodeList";
import { useTranslation } from "react-i18next";

window.jQuery = $;
window.$ = $;
global.jQuery = $;
const socket = new BuddibleSocket();
const util = new Utilities();
const codeList = new CodeList();

export default function FindIDModal() {
  const { t } = useTranslation();
  const $controllers = {
    USER_NM: useRef(),
    USER_TEL: useRef(),
  };

  function joinData(key, data) {
    let retData = {
      COMP_CD: "Y0001",
      USER_NM: $controllers.USER_NM.current.value,
      USER_TEL: $controllers.USER_TEL.current.value,
    };

    if (key === "METHOD") {
      retData.METHOD = data;
    }

    return retData;
  }

  function actionSave() {
    let updateData = joinData("METHOD", "FIND_EMAIL");
    requestFindID(updateData);
  }

  function checkValidation(updateData) {
    if (updateData.METHOD === "FIND_EMAIL") {
      if (updateData.USER_NM.trim() === "") {
        codeList.Modal.current.alert(
          t("commonNav.findIDModal.msg.enterName"),
          () => {
            $controllers.USER_NM.current.focus();
          }
        );
        return false;
      }

      if (util.validationMobileNumber(updateData.USER_TEL) === false) {
        codeList.Modal.current.alert(
          t("commonNav.findIDModal.msg.enterPhoneNumber"),
          () => {}
        );
        return false;
      }
    } else {
      return false;
    }

    return true;
  }

  function requestFindID(updateData) {
    if (checkValidation(updateData) === false) return;

    const msgID = util.makeUUIDv4();
    const socketMsg = {
      file: "/join/JS_join_gbts_private_find_id.php",
      msgID: msgID,
      data: {},
      ...updateData,
    };
    if (socketMsg.USER_PW) {
      socketMsg.USER_PW = util.buddibleEncrypt(socketMsg.USER_PW);
    }
    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        switch (updateData.METHOD) {
          case "FIND_EMAIL":
            if (newData["ret"] === true) {
              if (newData["returnData"].length !== 0) {
                codeList.Modal.current.alert(
                  `${t("commonNav.findIDModal.msg.noticeIDPrev")}[${
                    newData["returnData"][0].USER_ID
                  }]${t("commonNav.findIDModal.msg.noticeIDNext")}.`,
                  () => {}
                );
              } else {
                codeList.Modal.current.alert(
                  t("commonNav.findIDModal.msg.noRegistEmail"),
                  () => {}
                );
              }
            } else {
              codeList.Modal.current.alert(
                t("commonNav.findIDModal.msg.error"),
                () => {}
              );
            }

            break;
        }
      }
    });
  }

  return (
    <div
      className="modal fade"
      id="findIDModal"
      tabIndex="-1"
      aria-labelledby="findIDModalLabel"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div className="modal-dialog modal-dialog-centered modal-md">
        <div className="modal-content">
          <div className="modal-header py-2">
            <h5 className="modal-title h6 font-weight-bold m-0 p-0 text-freiscop">
              {t("commonNav.findIDModal.title")}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              id="findIDModalClose"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body p-2">
            <div className="container-fluid">
              <div className="py-3 d-block">
                <div className="mb-3 row">
                  <label className="col-form-label col-sm-3 text-end">
                    {t("commonNav.findIDModal.name")}
                  </label>
                  <div className="col-sm-9">
                    <input
                      type="email"
                      className="form-control"
                      ref={$controllers.USER_NM}
                    />
                  </div>
                </div>
                <div className="mb-3 row">
                  <label className="col-form-label col-sm-3 text-end">
                    {t("commonNav.findIDModal.phoneNumber")}
                  </label>
                  <div className="col-sm-9">
                    <input
                      type="tel"
                      className="form-control"
                      ref={$controllers.USER_TEL}
                    />
                  </div>
                </div>
              </div>
              <div className="text-danger">
                ※ {t("commonNav.findIDModal.warningNotice")}
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn_1"
              onClick={() => {
                actionSave();
              }}
            >
              {t("commonNav.findIDModal.submit")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
